// section: "company" | "contact"; primary: show by default (optional "More" for rest)
const companyFilterData = [
  {
    name: "Company Info",
    id: "companyDomain",
    action: "companyDomainName",
    section: "company",
    primary: true,
    icon: "language"
  },
  {
    name: "Industry",
    id: "industry",
    action: "autoCompleteMultiSelectDropdown",
    section: "company",
    primary: true,
    icon: "business"
  },
  {
    name: "HQ Location",
    id: "companyLocation",
    action: "autoCompleteMultiSelectDropdown",
    section: "company",
    primary: true,
    icon: "location_city"
  },
  {
    name: "Employee Size",
    id: "employeeCount",
    action: "multiSelectDropdown",
    section: "company",
    primary: true,
    icon: "group",
    options: [
      { id: "1 - 10", value: "1-10", show: true },
      { id: "11 - 20", value: "11-20", show: true },
      { id: "21 - 50", value: "21-50", show: true },
      { id: "51 - 100", value: "51-100", show: true },
      { id: "101 - 200", value: "101-200", show: true },
      { id: "201 - 500", value: "201-500", show: true },
      { id: "501 - 1000", value: "501-1000", show: true },
      { id: "1001 - 2000", value: "1001-2000", show: true },
      { id: "2001 - 5000", value: "2001-5000", show: true },
      { id: "5001 - 10000", value: "5001-10000", show: true },
      { id: "10000+", value: "10000+", show: true }
    ]
  },
  {
    name: "Annual Revenue",
    id: "revenue",
    action: "multiSelectDropdown",
    section: "company",
    primary: true,
    icon: "attach_money",
    // Ranges use end-exclusive boundaries (no overlap): $0-$0.1M = [0, 99999], $0.1M-$0.5M = [100000, 499999], etc.
    options: [
      { id: "0-99999", value: "$0 - $0.1M", show: true },
      { id: "100000-499999", value: "$0.1M - $0.5M", show: true },
      { id: "500000-999999", value: "$0.5M - $1M", show: true },
      { id: "1000000-4999999", value: "$1M - $5M", show: true },
      { id: "5000000-9999999", value: "$5M - $10M", show: true },
      { id: "10000000-24999999", value: "$10M - $25M", show: true },
      { id: "25000000-49999999", value: "$25M - $50M", show: true },
      { id: "50000000-99999999", value: "$50M - $100M", show: true },
      { id: "100000000-499999999", value: "$100M - $500M", show: true },
      { id: "500000000-999999999", value: "$500M - $1B", show: true },
      { id: "1000000000-4999999999", value: "$1B - $5B", show: true },
      { id: "5000000000-9999999999", value: "$5B - $10B", show: true },
      { id: "10000000000+", value: "$10B+", show: true }
    ]
  },
  {
    name: "Company Type",
    id: "companyType",
    action: "multiSelectDropdown",
    section: "company",
    primary: false,
    icon: "domain",
    options: [
      { id: "PRIVATELY_HELD", value: "Privately held", show: true },
      { id: "SELF_OWNED", value: "Self owned", show: true },
      { id: "SELF_EMPLOYED", value: "Self employed", show: true },
      { id: "PARTNERSHIP", value: "Partnership", show: true },
      { id: "PUBLIC_COMPANY", value: "Public company", show: true },
      { id: "NON_PROFIT", value: "Non-profit", show: true },
      { id: "EDUCATIONAL", value: "Educational", show: true },
      { id: "GOVERNMENT_AGENCY", value: "Government agency", show: true }
    ]
  },
  {
    name: "Founded Year",
    id: "foundedYear",
    action: "foundedYear",
    section: "company",
    primary: false,
    icon: "event"
  },
  {
    name: "Keywords",
    id: "companyKeywords",
    action: "autoCompleteMultiSelectDropdown",
    section: "company",
    primary: false,
    icon: "label"
  },
  {
    name: "Technologies",
    id: "technologies",
    action: "autoCompleteMultiSelectDropdown",
    section: "company",
    primary: false,
    icon: "memory"
  },
  {
    name: "Funding",
    id: "funding",
    action: "fundingDropdown",
    section: "company",
    primary: false,
    icon: "account_balance",
    showSearchPanel: true
  },
  {
    name: "Employees by Department",
    id: "employeesByDepartment",
    action: "employeesByDepartment",
    section: "company",
    primary: false,
    icon: "people"
  },
  {
    name: "Growth by Department",
    id: "growthByDepartment",
    action: "growthByDepartment",
    section: "company",
    primary: false,
    icon: "trending_up"
  }
];

const contactFilterData = [
  {
    name: "Contact Name",
    id: "name",
    action: "inputBox",
    section: "contact",
    primary: true,
    icon: "person"
  },
  {
    name: "Location",
    id: "location",
    action: "autoCompleteMultiSelectDropdown",
    section: "contact",
    primary: true,
    icon: "location_on"
  },
  {
    name: "Title",
    id: "title",
    action: "inputBox",
    section: "contact",
    primary: true,
    icon: "assignment_ind"
  },
  {
    name: "Job Function",
    id: "department",
    action: "jobFunctionDropdown",
    section: "contact",
    primary: true,
    icon: "work",
    showSearchPanel: true
  },
  {
    name: "Seniority Level",
    id: "level",
    action: "multiSelectDropdown",
    section: "contact",
    primary: true,
    icon: "star",
    showSearchPanel: false,
    options: [
      { id: "founder", value: "Founder", show: true },
      { id: "owner", value: "Owner", show: true },
      { id: "partner", value: "Partner", show: true },
      { id: "c_suite", value: "C-Suite", show: true },
      { id: "vp", value: "VP", show: true },
      { id: "director", value: "Director", show: true },
      { id: "head", value: "Head", show: true },
      { id: "manager", value: "Manager", show: true },
      { id: "senior", value: "Senior", show: true },
      { id: "mid-level", value: "Mid-Level", show: true },
      { id: "entry", value: "Entry", show: true },
      { id: "intern", value: "Intern", show: true }
    ]
  },
  {
    name: "Keywords",
    id: "contactKeywords",
    action: "autoCompleteMultiSelectDropdown",
    section: "contact",
    primary: false,
    icon: "label"
  },
  {
    name: "Profile Badge",
    id: "profileBadge",
    action: "multiSelectDropdown",
    section: "contact",
    primary: false,
    icon: "verified_user",
    options: [
      { id: "PREMIUM", value: "Premium", show: true },
      { id: "OPEN_TO_WORK", value: "Open to Work", show: true },
      { id: "INFLUENCER", value: "Influencer", show: true },
      { id: "CREATOR", value: "Creator", show: true },
      { id: "HIRING", value: "Hiring", show: true }
    ]
  },
  {
    name: "Experience",
    id: "experience",
    action: "experienceDuration",
    section: "contact",
    primary: false,
    icon: "schedule"
  },
  {
    name: "Skills",
    id: "skill",
    action: "inputBox",
    section: "contact",
    primary: false,
    icon: "code"
  },
  {
    name: "Certifications",
    id: "certification",
    action: "inputBox",
    section: "contact",
    primary: false,
    icon: "school"
  }
];

const DEFAULT_EXPERIENCE_DURATION = {
  experienceCurrentJobMinYear: 0,
  experienceCurrentJobMaxYear: 0,
  experienceCurrentJobMinMonth: 0,
  experienceCurrentJobMaxMonth: 0,
  experienceCurrentCompanyMinYear: 0,
  experienceCurrentCompanyMaxYear: 0,
  experienceCurrentCompanyMinMonth: 0,
  experienceCurrentCompanyMaxMonth: 0,
  experienceTotalMinYear: 0,
  experienceTotalMaxYear: 0,
  experienceTotalMinMonth: 0,
  experienceTotalMaxMonth: 0
};

const filterComponentData = [...companyFilterData, ...contactFilterData];

export { filterComponentData, companyFilterData, contactFilterData, DEFAULT_EXPERIENCE_DURATION };
export default filterComponentData;
